module.exports = __webpack_public_path__ + "img/error-dark.0e6cc648.svg";